<script lang="ts">
    import {getRouteById} from "../Nav";
    import type {ContactData, UserData} from "../Types";

    export let telegram_id: string | null
    export let phone: string | null
    $: href = '#'+getRouteById('Contact').hash(telegram_id, phone)
</script>
<a class="btn btn-sm btn-primary"
   title="Перейти до контакту"
   {href}
><slot></slot></a>
